
import {
  BlockText,
  BlockCTA,
} from '../implementations';

const mappers = {
  text: BlockText,
  cta: BlockCTA,
};

export default mappers;

